const callRoutes = {
    calls: '/calls',
    'calls.callRecordKey': '/calls/:callRecordKey',
    'calls.callRecordKey.contactKey': '/calls/:callRecordKey/:contactKey',
    'calls.callRecordKey.contact': '/calls/:callRecordKey/contact',
    'calls.callRecordKey.contactKey.calendar':
        '/calls/:callRecordKey/:contactKey/calendar',
    'calls.callRecordKey.list': '/calls/:callRecordKey/list',
};

const extensionRoutes = {
    extensions: '/extensions',
    'extensions.contact.contactKey': '/extensions/contact/:contactKey',
    'extensions.entityKey.contact': '/extensions/:entityKey/contact',
    'extensions.entityKey.contact.calendar':
        '/extensions/:entityKey/contact/calendar',
    'extensions.invite': '/extensions/invite',
    'extensions.thirdpartycontact.thirdPartyContactKey':
        '/extensions/thirdpartycontact/:thirdPartyContactKey',
    'extensions.overview': '/extensions/overview',
};

const messagesRoutes = {
    messages: '/messages',
    'messages.create': '/messages/create',
    'messages.meetings': '/messages/meetings',
    'messages.conferences.entityKey': '/messages/conferences/:entityKey',
    'messages.id': '/messages/:id',
    'messages.id.settings': '/messages/:id/settings',
    'messages.id.members': '/messages/:id/members',
    'messages.id.lobby': '/messages/:id/lobby',
    'messages.id.meeting': '/messages/:id/meeting',
    'messages.id.images': '/messages/:id/images',
    'messages.id.files': '/messages/:id/files',
    'messages.id.posts': '/messages/:id/posts',
    'messages.id.drive': '/messages/:id/drive',
    'messages.id.redirect': '/messages/redirect/chatsession/:chatUserKey',
    'messages.id.redirect.lobby':
        '/messages/redirect/chatsession/:chatUserKey/lobby',
    'messages.overview': '/messages/overview',
    'messages.id.contact.key': '/messages/:id/contact/:extensionKey',
    'messages.id.post.messageKey.contact.key':
        '/messages/:id/post/:messageKey/contact/:extensionKey',
    'messages.id.members.contact.key':
        '/messages/:id/members/contact/:extensionKey',
    'messages.id.settings.poat.contact.key':
        '/messages/:id/settings/posts/:messageKey/contact/:extensionKey',
    'messages.id.settings.members.contact.key':
        '/messages/:id/settings/members/contact/:extensionKey',
    'messages.id.settings.contact.key':
        '/messages/:id/settings/contact/:extensionKey',

    'messages.id.members.contact.key.calendar':
        '/messages/:id/members/contact/:extensionKey/calendar',
    'messages.id.settings.members.contact.key.calendar':
        '/messages/:id/settings/members/contact/:extensionKey/calendar',
    'messages.id.settings.contact.key.calendar':
        '/messages/:id/settings/contact/:extensionKey/calendar',
    'messages.id.contact.key.calendar':
        '/messages/:id/contact/:extensionKey/calendar',
};

const pbxRoutes = {
    pbx: '/pbx',
    'pbx.navigation': '/pbx/:department/:entityKey',
    'pbx.channels.entityKey': '/pbx/channels/:entityKey',
    'pbx.channels.channelKey.members': '/pbx/channels/:channelKey/members',
    'pbx.channels.channelKey.members.remove':
        '/pbx/channels/:channelKey/members/remove',
    'pbx.channels.entityKey.profiles': '/pbx/channels/:entityKey/profiles',
    'pbx.channels.entityKey.profiles.calendar':
        '/pbx/channels/:entityKey/profiles/calendar',
    'pbx.channels.channelKey.settings': '/pbx/channels/:channelKey/settings',
    'pbx.channels.channelKey.settings.greeting':
        '/pbx/channels/:channelKey/settings/greeting',
    'pbx.channels.entityKey.settings.greeting.profileKey':
        '/pbx/channels/:entityKey/settings/greeting/:profileKey',
    'pbx.channels.entityKey.settings.statistics':
        '/pbx/channels/:entityKey/settings/statistics',
    'pbx.channels.entityKey.statistics': '/pbx/channels/:entityKey/statistics',
    'pbx.channels.channelKey.chatSessionKey':
        '/pbx/channels/:channelKey/:chatSessionKey',
    'pbx.channels.channelKey.chatSessionKey.settings':
        '/pbx/channels/:channelKey/:chatSessionKey/settings',
    'pbx.conference': '/pbx/conference',
    'pbx.conference.meetingCode': '/pbx/conference/:meetingCode',
    'pbx.conferences.entityKey': '/pbx/conferences/:entityKey',
    'pbx.connections.connectionKey': '/pbx/connections/:connectionKey',
    'pbx.overview': '/pbx/overview',
    'pbx.overview.entityKey.pbxProfiles':
        '/pbx/overview/:entityKey/pbx-profiles',
    'pbx.overview.queueKey.members': '/pbx/overview/:queueKey/members',
    'pbx.overview.queueKey.members.edit':
        '/pbx/overview/:queueKey/members/edit',
    'pbx.queues.entityKey': '/pbx/queues/:entityKey',
    'pbx.queues.queueKey.members': '/pbx/queues/:queueKey/members',
    'pbx.queues.queueKey.connections':
        '/pbx/queues/:queueKey/connections/:channelType',
    'pbx.queues.queueKey.members.edit': '/pbx/queues/:queueKey/members/edit',
    'pbx.queues.queueKey.callRecordKey': '/pbx/queues/:queueKey/:callRecordKey',
    'pbx.queues.entityKey.number.callRecordKey.contact':
        '/pbx/queues/:entityKey/:bPart/:callRecordKey/contact',
    'pbx.queues.entityKey.number.callRecordKey.contactKey':
        '/pbx/queues/:entityKey/:bPart/:callRecordKey/:contactKey',
    'pbx.queues.entityKey.number.callRecordKey.contactKey.calendar':
        '/pbx/queues/:entityKey/:bPart/:callRecordKey/:contactKey/calendar',
    'pbx.queues.entityKey.profiles': '/pbx/queues/:entityKey/profiles',
    'pbx.queues.entityKey.profiles.calendar':
        '/pbx/queues/:entityKey/profiles/calendar',
    'pbx.queues.entityKey.settings': '/pbx/queues/:entityKey/settings',
    'pbx.queues.entityKey.settings.calendar':
        '/pbx/queues/:entityKey/settings/calendar',
    'pbx.queues.queueKey.settings.callstrategy':
        '/pbx/queues/:queueKey/settings/callstrategy',
    'pbx.queues.queueKey.settings.callstrategy.edit':
        '/pbx/queues/:queueKey/settings/callstrategy/edit',
    'pbx.queues.entityKey.settings.edit.name':
        '/pbx/queues/:entityKey/settings/edit/name',
    'pbx.queues.queueKey.settings.members':
        '/pbx/queues/:queueKey/settings/members',
    'pbx.queues.queueKey.settings.members.edit':
        '/pbx/queues/:queueKey/settings/members/edit',
    'pbx.queues.entityKey.settings.statistics':
        '/pbx/queues/:entityKey/settings/statistics',
    'pbx.queues.entityKey.settings.autoreply':
        '/pbx/queues/:entityKey/settings/autoreply',

    'pbx.queues.entityKey.settings.autoreply.profileKey':
        '/pbx/queues/:entityKey/settings/autoreply/:profileKey',

    'pbx.queues.entityKey.settings.autoreply.profileKey.messageType':
        '/pbx/queues/:entityKey/settings/autoreply/:profileKey/:messageType',

    'pbx.queues.entityKey.settings.tickets':
        '/pbx/queues/:entityKey/settings/tickets',
    'pbx.queues.entityKey.settings.tickets.create':
        '/pbx/queues/:entityKey/settings/tickets/create',
    'pbx.queues.entityKey.settings.tickets.visibility':
        '/pbx/queues/:entityKey/settings/tickets/visibility',
    'pbx.queues.entityKey.settings.waitingsound':
        '/pbx/queues/:entityKey/settings/waitingsound',
    'pbx.queues.entityKey.settings.welcomemessage':
        '/pbx/queues/:entityKey/settings/welcomemessage',
    'pbx.queues.entityKey.settings.welcomemessage.open':
        '/pbx/queues/:entityKey/settings/welcomemessage/open',
    'pbx.queues.entityKey.settings.welcomemessage.profileKey':
        '/pbx/queues/:entityKey/settings/welcomemessage/:profileKey',
    'pbx.queues.entityKey.settings.welcomemessage.profileKey.redirect':
        '/pbx/queues/:entityKey/settings/welcomemessage/:profileKey/redirect',
    'pbx.queues.entityKey.settings.welcomemessage.profileKey.sound':
        '/pbx/queues/:entityKey/settings/welcomemessage/:profileKey/sound',
    'pbx.queues.entityKey.settings.welcomemessage.sounds':
        '/pbx/queues/:entityKey/settings/welcomemessage/sounds',
    'pbx.queues.entityKey.statistics': '/pbx/queues/:entityKey/statistics',
    'pbx.refers.entityKey': '/pbx/refers/:entityKey',
    'pbx.refers.entityKey.profiles': '/pbx/refers/:entityKey/profiles',
    'pbx.refers.entityKey.profiles.calendar':
        '/pbx/refers/:entityKey/profiles/calendar',
    'pbx.voicemails.entityKey': '/pbx/voicemails/:entityKey',
    'pbx.voicemails.entityKey.settings': '/pbx/voicemails/:entityKey/settings',
    'pbx.voicemails.entityKey.settings.edit.name':
        '/pbx/voicemails/:entityKey/settings/edit/name',
    'pbx.voicemails.entityKey.settings.edit.setting':
        '/pbx/voicemails/:entityKey/settings/edit/:setting',
    'pbx.voicemails.voicemailKey.settings.sound':
        '/pbx/voicemails/:voicemailKey/settings/sound',
    'pbx.voicemails.entityKey.settings.edit.number':
        '/pbx/voicemails/:entityKey/settings/edit/number',
    'pbx.voicemails.entityKey.settings.edit.email':
        '/pbx/voicemails/:entityKey/settings/edit/email',
};

const settingRoutes = {
    settings: '/settings/:extensionKey',
    'settings.account': '/settings/:extensionKey/account',
    'settings.account.license': '/settings/:extensionKey/account/license',
    'settings.account.contact': '/settings/:extensionKey/account/contact',
    'settings.account.username-password':
        '/settings/:extensionKey/account/username-password',
    'settings.account.username-password.email':
        '/settings/:extensionKey/account/username-password/:credentialId',
    'settings.account.username-password.email.register':
        '/settings/:extensionKey/account/username-password/email/register',
    'settings.account.username-password.manageTokens':
        '/settings/:extensionKey/account/username-password/manage-tokens',
    'settings.account.authentication':
        '/settings/:extensionKey/account/username-password',
    'settings.transcriptions': '/settings/:extensionKey/transcriptions',
    'settings.transcriptions.quota':
        '/settings/:extensionKey/transcriptions/quota',
    'settings.transcriptions.call-summary':
        '/settings/:extensionKey/transcriptions/call-summary',
    'settings.account.socialintegration.integration':
        '/settings/:extensionKey/account/socialintegration/:syncSource',
    'settings.account.socialintegration.integration.callback':
        '/settings/:extensionKey/account/socialintegration/callback/:syncSource',

    'settings.general': '/settings/:extensionKey/general',
    'settings.general.reportlogs': '/settings/:extensionKey/general/reportlogs',
    'settings.general.localechange':
        '/settings/:extensionKey/general/localechange',
    'settings.general.release': '/settings/:extensionKey/general/release',
    'settings.general.keyboardShortcuts':
        '/settings/:extensionKey/general/keyboardshortcuts',

    'settings.softphone': '/settings/:extensionKey/softphone',
    'settings.softphone.outgoing-calls':
        '/settings/:extensionKey/softphone/outgoing-calls',
    'settings.softphone.callmethod':
        '/settings/:extensionKey/softphone/callmethod',
    'settings.softphone.ringtone': '/settings/:extensionKey/softphone/ringtone',
    'settings.softphone.ringtone.select-ringtone':
        '/settings/:extensionKey/softphone/ringtone/select-ringtone',
    'settings.softphone.ringtone.audio-output':
        '/settings/:extensionKey/softphone/ringtone/audio-output',
    'settings.softphone.audio-in-out':
        '/settings/:extensionKey/softphone/audio-in-out',
    'settings.softphone.audio-in-out.audio-output':
        '/settings/:extensionKey/softphone/audio-in-out/audio-output',
    'settings.softphone.audio-in-out.microphone':
        '/settings/:extensionKey/softphone/audio-in-out/microphone',
    'settings.softphone.incoming-calls':
        '/settings/:extensionKey/softphone/incoming-calls',
    'settings.softphone.advanced': '/settings/:extensionKey/softphone/advanced',
    'settings.softphone.advanced.blind-transfer':
        '/settings/:extensionKey/softphone/blind_transfer',
    'settings.softphone.advanced.callrouting':
        '/settings/:extensionKey/softphone/advanced/callrouting',
    'settings.softphone.advanced.callwidgets':
        '/settings/:extensionKey/softphone/advanced/callwidgets',

    'settings.softphone.advanced.callwidgets.callwidgetKey':
        '/settings/:extensionKey/softphone/advanced/callwidgets/:callwidgetKey',
    'settings.softphone.advanced.callwidgets.callwidgetKey.triggertype':
        '/settings/:extensionKey/softphone/advanced/callwidgets/:callwidgetKey/triggertype',
    'settings.mobile': '/settings/:extensionKey/mobile',
    'settings.mobile.simKey': '/settings/:extensionKey/mobile/:simKey',

    'settings.mobile.simKey.details':
        '/settings/:extensionKey/mobile/:simKey/details',
    'settings.mobile.simKey.roaming':
        '/settings/:extensionKey/mobile/:simKey/roaming',

    'settings.mobile.esim': '/settings/:extensionKey/mobile/esim',
    'settings.mobile.extradata': '/settings/:extensionKey/mobile/extradata',
    'settings.voicemail': '/settings/:extensionKey/voicemail',
    'settings.voicemail.busy': '/settings/:extensionKey/voicemail/busy',
    'settings.voicemail.unavailable':
        '/settings/:extensionKey/voicemail/unavailable',
    'settings.voicemail.sound': '/settings/:extensionKey/voicemail/sound',
    'settings.voicemail.login': '/settings/:extensionKey/voicemail/login',
    'settings.voicemail.notify': '/settings/:extensionKey/voicemail/notify',
    'settings.voicemail.alternatives':
        '/settings/:extensionKey/voicemail/alternatives',
    'settings.voicemail.alternatives.redialtype':
        '/settings/:extensionKey/voicemail/alternatives/redialtype',
    'settings.cti-settings': '/settings/:extensionKey/cti-settings',
    'settings.cti-settings.showonload':
        '/settings/:extensionKey/cti-settings/showonload',
    'settings.cti-settings.openoncall':
        '/settings/:extensionKey/cti-settings/openoncall',
    'settings.cti-settings.openonanswer':
        '/settings/:extensionKey/cti-settings/openonanswer',
    'settings.dashboards': '/settings/:extensionKey/dashboards',
    'settings.dashboards.create.templates-picker':
        '/settings/:extensionKey/dashboards/templates',
    'settings.dashboards.create':
        '/settings/:extensionKey/dashboards/templates/:wallboardTypePath',
    'settings.dashboards.edit':
        '/settings/:extensionKey/dashboards/:wallboardKey',
    'settings.notifications': '/settings/:extensionKey/notifications',
    'settings.notifications.device.pushType':
        '/settings/:extensionKey/notifications/:device/:pushType',
    'settings.callerid': '/settings/:extensionKey/callerid',
    'settings.callerid.edit.numberType':
        '/settings/:extensionKey/callerid/edit/:numberType',
    'settings.callerid.profile.numberType':
        '/settings/:extensionKey/callerid/profile/:numberType',
    'settings.callerid.profile.numberType.edit.profileKey':
        '/settings/:extensionKey/callerid/profile/:numberType/edit/:profileKey',
    'settings.callerid.edit.sms': '/settings/:extensionKey/callerid/edit/sms',
    'settings.callerid.profile.sms':
        '/settings/:extensionKey/callerid/profile/sms',
    'settings.callerid.profile.sms.edit.profileKey':
        '/settings/:extensionKey/callerid/sms/edit/:profileKey',
    'settings.incoming-calls': '/settings/:extensionKey/incoming-calls',
    'settings.incoming-calls.profileKey':
        '/settings/:extensionKey/incoming-calls/:profileKey',
    'settings.incoming-calls.profileKey.settingType':
        '/settings/:extensionKey/incoming-calls/:profileKey/:settingType',
    'settings.call-recording.settings':
        '/settings/:extensionKey/call-recording/settings',
    'settings.call-recording-and-monitoring':
        '/settings/:extensionKey/call-recording-and-monitoring',
    'settings.call-recording-and-monitoring.monitoring':
        '/settings/:extensionKey/call-recording-and-monitoring/monitoring',
    'settings.call-recording-and-monitoring.settings':
        '/settings/:extensionKey/call-recording-and-monitoring/:settingType',
    'settings.call-recording-and-monitoring.settings.profileKey':
        '/settings/:extensionKey/call-recording-and-monitoring/:settingType/:profileKey',
    'settings.profiles': '/settings/:extensionKey/profiles',
    'settings.profiles.profileKey':
        '/settings/:extensionKey/profiles/:profileKey',
    'settings.profiles.profileKey.availability':
        '/settings/:extensionKey/profiles/:profileKey/availability',
    'settings.profiles.profileKey.availability.priority':
        '/settings/:extensionKey/profiles/:profileKey/availability/priority',
    'settings.profiles.profileKey.call-recording-and-monitoring':
        '/settings/:extensionKey/profiles/:profileKey/call-recording-and-monitoring',
    'settings.profiles.profileKey.call-recording-and-monitoring.settingsType':
        '/settings/:extensionKey/profiles/:profileKey/call-recording-and-monitoring/:settingsType',
    'settings.profiles.profileKey.callerId':
        '/settings/:extensionKey/profiles/:profileKey/callerId',
    'settings.profiles.profileKey.duration':
        '/settings/:extensionKey/profiles/:profileKey/duration',
    'settings.profiles.profileKey.incoming-calls':
        '/settings/:extensionKey/profiles/:profileKey/incoming-calls',
    'settings.profiles.profileKey.incoming-calls.settingType':
        '/settings/:extensionKey/profiles/:profileKey/incoming-calls/:settingType',
    'settings.profiles.profileKey.name':
        '/settings/:extensionKey/profiles/:profileKey/name',
    'settings.profiles.profileKey.note':
        '/settings/:extensionKey/profiles/:profileKey/note',
    'settings.profiles.profileKey.notifications':
        '/settings/:extensionKey/profiles/:profileKey/notifications',
    'settings.profiles.profileKey.queue-and-chat-login':
        '/settings/:extensionKey/profiles/:profileKey/queue-and-chat-login',
    'settings.profiles.profileKey.queue-and-chat-login.channelKey':
        '/settings/:extensionKey/profiles/:profileKey/queue-and-chat-login/:channelKey',
    'settings.profiles.profileKey.queue-and-chat-login.queueKey':
        '/settings/:extensionKey/profiles/:profileKey/queue-and-chat-login/:queueKey',
    'settings.work-hours': '/settings/:extensionKey/work-hours',
    'settings.queue-and-chat-login':
        '/settings/:extensionKey/queue-and-chat-login',
    'settings.queue-and-chat-login.queueKey':
        '/settings/:extensionKey/queue-and-chat-login/queue-login/:queueKey',
    'settings.queue-and-chat-login.channelKey':
        '/settings/:extensionKey/queue-and-chat-login/channel-login/:channelKey',
    'settings.softphone.advanced.callrouting.type':
        '/settings/:extensionKey/softphone/advanced/callrouting/:type',
    'settings.softphone.advanced.callrouting.type.add':
        '/settings/:extensionKey/softphone/advanced/callrouting/:type/add',
    'settings.softphone.advanced.callrouting.type.blocklistKey':
        '/settings/:extensionKey/softphone/advanced/callrouting/:type/:blocklistKey',
    'settings.softphone.advanced.callrouting.type.blocklistKey.action':
        '/settings/:extensionKey/softphone/advanced/callrouting/:type/:blocklistKey/action',
    'settings.softphone.advanced.callrouting.type.blocklistKey.exception':
        '/settings/:extensionKey/softphone/advanced/callrouting/:type/:blocklistKey/exception',
    'settings.softphone.advanced.callrouting.type.blocklistKey.exception.add':
        '/settings/:extensionKey/softphone/advanced/callrouting/:type/:blocklistKey/exception/add',
    'settings.softphone.advanced.callrouting.type.blocklistKey.during':
        '/settings/:extensionKey/softphone/advanced/callrouting/:type/:blocklistKey/during',
};

const ticketRoutes = {
    tickets: '/tickets',
    'tickets.ticketKey': '/tickets/:ticketKey',
};

const videoMeeting = {
    videoLink: '/video',
};

const omniRoutes = {
    omni: '/omni',
};

const aiRoutes = {
    'ai-coworker.entityKey.contact':
        '/extensions/:extensionKey/ai-coworker/contact',
    'ai-coworker.settings.modes':
        '/extensions/:extensionKey/ai-coworker/settings/modes',
    'ai-coworker.settings.modes.profileKey':
        '/extensions/:extensionKey/ai-coworker/settings/modes/:profileKey',
    'pbx.aicoworker.extensionKey.calls.callRecordKey':
        '/pbx/ai-coworker/:extensionKey/calls/:callRecordKey',
    'pbx.aicoworker.extensionKey': '/pbx/ai-coworker/:extensionKey',
    'pbx.aicoworker.extensionKey.settings':
        '/pbx/ai-coworker/:extensionKey/settings',
    'pbx.aicoworker.extensionKey.settings.general':
        '/pbx/ai-coworker/:extensionKey/settings/general',
    'pbx.aicoworker.extensionKey.settings.queuing-system-login':
        '/pbx/ai-coworker/:extensionKey/settings/queuing-system-login',
    'pbx.aicoworker.extensionKey.settings.queuing-system-login.queueKey':
        '/pbx/ai-coworker/:extensionKey/settings/queuing-system-login/:queueKey',
    'ai-studio.page': '/ai-studio',
};

const main = {
    signin: '/signin',
    uaePassCallback: '/auth/uaepass/callback',
};

export const routes = {
    ...callRoutes,
    ...extensionRoutes,
    ...messagesRoutes,
    ...pbxRoutes,
    ...settingRoutes,
    ...ticketRoutes,
    ...omniRoutes,
    ...videoMeeting,
    ...aiRoutes,
    ...main,
};

export type RouteKey = keyof typeof routes;
